import { useEffect, useState } from 'react'
import { signinRedirectCallback } from './App'
import { useHistory } from 'react-router-dom'
import LoadingSpinner from './components/LoadingSpinner'
import NoOIDCAppAccess from './components/NoOIDCAppAccess';

function SigninOidc() {
	const history = useHistory();
	const [message, setMessage] = useState<string>("");

	useEffect(() => {
		async function signinAsync() {
			try {
				setMessage("");
				await signinRedirectCallback()
				history.push('/accounts')
			}
			catch (e: any) {
				setMessage(e.message);
				console.log(e.message)
			}
		}
		signinAsync()
	}, [history])

	return (
		message === "" ? <LoadingSpinner /> : <NoOIDCAppAccess message={message} />
	)
}

export default SigninOidc
